import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-container">
                <img src="/logo.svg" alt="MCA Logo" className="footer-logo-image" />
                <div className="logo-text-container">
                  <span className="logo-text">MCA</span>
                  <span className="logo-subtitle">Muslim Corporate Academy</span>
                </div>
              </div>
            </div>
            <p className="footer-description">
            Empowering Students to Pursue Impactful Roles through Islamic Principles
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">About</h4>
            <nav className="footer-nav">
              <Link to="/mission" className="footer-link">Our Mission</Link>
              <Link to="/mentors" className="footer-link">Our Mentors</Link>
              <Link to="/ethos" className="footer-link">Our Ethos</Link>
            </nav>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <nav className="footer-nav">
              <Link to="/tuition" className="footer-link">Tuition</Link>
              <Link to="/personal-statement" className="footer-link">University Application Support</Link>
              <Link to="/cv-support" className="footer-link">Corporate Application Support</Link>
            </nav>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Insights</h4>
            <nav className="footer-nav">
              <Link to="/blog" className="footer-link">Biweekly Blog</Link>
              <Link to="/socials" className="footer-link">Our Socials</Link>
            </nav>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Support</h4>
            <nav className="footer-nav">
              <Link to="/get-involved" className="footer-link">Get Involved</Link>
              <Link to="/faq" className="footer-link">FAQ</Link>
            </nav>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <div className="footer-contact">
                        <a href="mailto:info@muslimcorporateacademy.org" className="footer-link">
                          info@muslimcorporateacademy.org
                        </a>
              <p className="footer-text">Available for inquiries</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Follow Us</h4>
            <div className="social-links">
              <a href="https://linkedin.com/company/muslim-corporate-academy" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/mca.uk?igsh=aHExeGQwajdoYWUw" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@mca_uk?_t=ZN-8zmFc1nELHa&_r=1" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="TikTok">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M9.4 3h3.2c.2 1.8 1.6 3.3 3.4 3.5v3.1c-1.3 0-2.5-.4-3.4-1v5.6c0 2.9-2.3 5.3-5.2 5.3S2 17.1 2 14.2s2.3-5.3 5.2-5.3c.4 0 .8 0 1.2.1v3.2c-.4-.1-.8-.1-1.2-.1-1.2 0-2.1 1-2.1 2.1s.9 2.1 2.1 2.1 2.1-1 2.1-2.1V3z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2025 Muslim Corporate Academy. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 